import { createAction } from "@reduxjs/toolkit";

const changeMenuActive = createAction(
  "MENU/changeMenuActive",
  (value: string[]) => ({
    payload: value,
  })
);

export const menuAction = { changeMenuActive };
